import React from "react";
import { ArrowRight, Clock } from "lucide-react";
import { BLOGS } from "../mock";
import Reveal from "../components/Reveal";

const BlogPage = () => (
  <main>
    <section className="bg-gradient-to-br from-[#eef4fb] to-[#fdf3e6] py-14 text-center">
      <div className="max-w-3xl mx-auto px-4">
        <Reveal>
          <span className="text-orange-brand font-bold text-sm uppercase tracking-wide">Our Articles</span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-navy font-head mt-2">Laundryma Blog</h1>
          <p className="text-navy/70 mt-4">Tips, guides and expert advice on garment care, laundry and dry cleaning.</p>
        </Reveal>
      </div>
    </section>

    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
        {[...BLOGS, ...BLOGS].map((b, i) => (
          <Reveal key={i} delay={(i % 3) * 60}>
            <article className="group bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-all cursor-pointer h-full flex flex-col">
              <div className="overflow-hidden h-52">
                <img src={`${b.img}?w=600&q=75`} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <span className="text-xs text-navy/40 flex items-center gap-1.5 mb-2"><Clock size={13} /> 5 min read</span>
                <h3 className="font-semibold text-lg text-navy font-head leading-snug group-hover:text-orange-brand transition-colors line-clamp-2">{b.title}</h3>
                <p className="text-sm text-navy/60 mt-2 line-clamp-3 flex-1">{b.excerpt}</p>
                <span className="text-orange-brand font-semibold text-sm mt-4 inline-flex items-center gap-1.5">Read More <ArrowRight size={15} /></span>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  </main>
);

export default BlogPage;
